
<linkable-item
  :class="['notification-item', { unread: !notification.read }]"
  as="router-link"
  hide-router-link-active
  :to="link"
  :data-id="notification.id"
  @click.native="markAsRead"
>
  <align direction="flex-start">
    <div>
      <card-image
        v-if="notification.card && notification.card.image"
        :image-url="notification.card.image"
      />

      <div v-else class="icon-wrapper">
        <icon :name="notificationIcon" />
      </div>
    </div>

    <div class="text">
      {{ notification.title }}
    </div>
  </align>
</linkable-item>
